function unique_array(arr) {
  const cart = [];

  for (let i = 0; i < arr.length; i++) {
      if (typeof arr[i] == "string") {
        const pkValue = parseInt(arr[i]);
        if(pkValue > 0 && cart.indexOf(pkValue) < 0) cart.push(pkValue);
      } else if (typeof arr[i] == "number") {
        const pkValue = arr[i];
        if(pkValue > 0 && cart.indexOf(pkValue) < 0) cart.push(pkValue);
      }
  }
  
  return cart;
}

function stripTag(str) {
  return str.replace(/<[^>]+>/g, '').trim();
}

function setHandphone(handphone) {
  let result;
  if (Array.isArray(handphone)) result = handphone.join("-");
  else result = handphone;
  if (result === "--") result = "";

  return result;
}

async function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// 숫자를 comma로 구분하는 함수
function number_format(num) {
  // 숫자 및 부호를 포함한 문자열을 허용
  if (typeof num !== 'string') {
    num = String(num);
  }

  // 정규 표현식을 사용하여 숫자를 천 단위로 구분
  return num.replace(/([+-]?\d+)(\d{3})/, "$1,$2").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

// 숫자로 변환 컴마두 빼고
function int_format(str) {
  return Number(str.replace(/,/g, ''));
}

// 숫자를 만 단위로 한글로 표시하는 함수
function number_to_korean(num, min=10000, isShort=true) {
  const units = ['', '만', '억', '조', '경'];
  let result = '';
  let unitIndex = 0;

  num = parseInt(num / min) * min;

  while (num > 0) {
    const part = num % 10000;
    if (part > 0) {
      if (isShort && unitIndex === 0 && part < min) {
        // isShort가 true이고 최소 단위 이하의 숫자일 경우 버림
        result = part + result;
      } else {
        if (part % 1000 === 0) {
          result = (part / 1000) + '천' + units[unitIndex] + ' ' + result;
        } else {
          result = part + units[unitIndex] + ' ' + result;
        }
      }
    }
    num = Math.floor(num / 10000);
    unitIndex++;
  }

  return result.trim();
}

function isRegistNum(jumin) {
  if (typeof jumin !== 'string' || jumin.length !== 13) {
    return false;
  }

  const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(jumin[i]) * weights[i];
  }

  let remainder = (11 - (sum % 11)) % 10;
  return remainder === parseInt(jumin[12]);
}

module.exports = {
  unique_array,
  stripTag,
  setHandphone,
  sleep,
  number_format,
  int_format,
  number_to_korean,
  isRegistNum,
};
